
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Filter, Download } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ImportEventsDialog from './ImportEventsDialog';
import { toast } from 'sonner';

const GigFilters: React.FC = () => {
  const [showImportDialog, setShowImportDialog] = useState(false);

  const handleImportComplete = (events: any[]) => {
    // In a real app, we would save these events to the state/database
    toast.success(`${events.length} events imported successfully`);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm" className="h-9 gap-1">
              <Filter className="h-4 w-4" />
              <span className="hidden sm:inline">Filters</span>
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[200px] p-3" align="end">
            <div className="space-y-4">
              <div className="space-y-2">
                <p className="text-sm font-medium">Status</p>
                <div className="flex flex-wrap gap-1">
                  <Badge variant="outline" className="cursor-pointer">All</Badge>
                  <Badge variant="default" className="cursor-pointer">Confirmed</Badge>
                  <Badge variant="outline" className="cursor-pointer">Pending</Badge>
                  <Badge variant="outline" className="cursor-pointer">Inquiries</Badge>
                </div>
              </div>
              
              <div className="space-y-2">
                <p className="text-sm font-medium">Date Range</p>
                <div className="flex flex-wrap gap-1">
                  <Badge variant="default" className="cursor-pointer">Upcoming</Badge>
                  <Badge variant="outline" className="cursor-pointer">This Month</Badge>
                  <Badge variant="outline" className="cursor-pointer">Next 3 Months</Badge>
                  <Badge variant="outline" className="cursor-pointer">Past</Badge>
                </div>
              </div>
              
              <div className="space-y-2">
                <p className="text-sm font-medium">Source</p>
                <div className="flex flex-wrap gap-1">
                  <Badge variant="default" className="cursor-pointer">All</Badge>
                  <Badge variant="outline" className="cursor-pointer">Local</Badge>
                  <Badge variant="outline" className="cursor-pointer">Songkick</Badge>
                  <Badge variant="outline" className="cursor-pointer">Eventbrite</Badge>
                </div>
              </div>
            </div>
          </PopoverContent>
        </Popover>
        
        <Button 
          variant="outline" 
          size="sm" 
          className="h-9 gap-1"
          onClick={() => setShowImportDialog(true)}
        >
          <Download className="h-4 w-4" />
          <span className="hidden sm:inline">Import Events</span>
        </Button>
      </div>
      
      <ImportEventsDialog 
        open={showImportDialog} 
        onOpenChange={setShowImportDialog}
        onImportComplete={handleImportComplete}
      />
    </>
  );
};

export default GigFilters;
